module.exports = __webpack_public_path__ + "media/stylesheets/images/userway_logo_images/caribou-coffee-d6cb26e920f1cfa9f7968a0bb3bf3025.png";